import { newTracker, setUserId, trackPageView } from '@snowplow/browser-tracker';
import { TimezonePlugin } from '@snowplow/browser-plugin-timezone';
import { SiteTrackingPlugin } from '@snowplow/browser-plugin-site-tracking';
import {
  LinkClickTrackingPlugin,
  refreshLinkClickTracking,
  enableLinkClickTracking,
} from '@snowplow/browser-plugin-link-click-tracking';
import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';
import { useIndexStore } from '~/store';

// Конфиг общий с bh-front: тот же коллектор и appId, сайты различаются по url событий
export default defineNuxtPlugin({
  name: 'snowplow',
  setup() {
    // остальные опции совпадают с дефолтами @snowplow/browser-tracker v3
    newTracker('sp1', 'a.lifehacker.ru/lifehacker/', {
      appId: 'lh-snowplow',
      cookieSameSite: 'Lax',
      encodeBase64: false,
      maxPostBytes: 50_000,
      maxLocalStorageQueueSize: 2000,
      connectionTimeout: 3500,
      contexts: {
        webPage: true,
        session: true,
      },
      postPath: 'tracker',
      // SiteTrackingPlugin нужен для trackSocialInteraction в Reaction.vue и ShareBlock.ts
      plugins: [LinkClickTrackingPlugin(), TimezonePlugin(), SiteTrackingPlugin()],
    });

    // ! user_id
    // * subId из токена равен integer_id пользователя; берём его сразу, чтобы первый pageview ушёл с uid,
    // * не дожидаясь асинхронной загрузки профиля в init.client.ts
    const accessToken = getAccessToken();
    setUserId((accessToken && getSubId(accessToken)) || null);

    const indexStore = useIndexStore();
    watch(
      () => indexStore.userIntegerId,
      (userId) => setUserId(userId ? String(userId) : null),
    );

    trackPageView();

    // ! clicks
    enableLinkClickTracking({ pseudoClicks: true, trackContent: true });
    // * snowplow v3 навешивает обработчики только на ссылки, которые есть в DOM в момент вызова,
    // * поэтому ссылки подгружаемых позже блоков перенавешиваем раз в секунду
    setInterval(() => {
      refreshLinkClickTracking();
    }, 1000);
  },
});
